<script setup>
import { ref, defineProps, onMounted, onBeforeUnmount} from 'vue'
import Chart from 'chart.js/auto';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

// import Multiselect from "vue-multiselect";
// import 'vue-multiselect/dist/vue-multiselect.min.css' 
// ドロップダウンに表示するサンプルオプション
const dataCrops = ref ([ 
  { id : 1 , name : 'オクラ' }, 
  { id : 2 , name : 'バナナ' }, 
  { id : 3 , name : 'マンゴー' }, 
  { id : 4 , name : 'リンゴ' }, 
  { id : 5 , name : 'なす' }, 
  { id : 6 , name : 'スイカ' }, 
  { id : 7 , name : 'レモン' }, 
  { id : 8 , name : 'コメ' }, 
  { id : 9 , name : 'ゴーヤー' }, 
  { id : 10 , name : 'レタス' }, 
  { id : 11 , name : 'トウモロコシ' }, 
])
const dataCosts = ref ([ 
  { id : 1 , name : '人件費' }, 
  { id : 2 , name : '育苗費' }, 
  { id : 3 , name : '肥料費' }, 
  { id : 4 , name : '農薬費' }, 
  { id : 5 , name : '農機具費' }, 
  { id : 6 , name : 'その他' }, 
])
// 選択されたオプションを保持する状態
const selectedCrops = ref ( null ) 
const selectedCosts = ref ( null ) 

// グラフ用データ読み込み
import costData from "../assets/cost.json"
let chartData = costData;

// let costItems = costData.datasets.map(data => data["label"]);
let chartInstance = null;
let chartType = 'bar';
let chartStack = false;

const date = ref();

const props = defineProps(['field'])
const field = ref(props.field)

onMounted(() => {
  date.value = new Date().toLocaleDateString('sv-SE').toString().substring(0, 10);

  if (field?.value) {
    drawChart('bar', false);
  }
})

onBeforeUnmount(() => {
})

// グラフ描画処理
function drawChart(type, stacked) {
  // グラフ生成
  var ctx = document.getElementById('chartCost');
  chartInstance = new Chart(ctx, {
    type: type,
    data: chartData,
    options: {
        scales: {
            y: {
                beginAtZero: true,
                stacked: stacked
            },
            x: {
                ticks: {
                  maxTicksLimit:10
                },
                stacked: stacked
            }
        }
    }
  });
}

// function onChangeCostItem(event) {
//   console.log(event);

//   if (event.target.checked) {
//     costItems.push(event.target.value);
//   }
//   else {
//     costItems = costItems.filter(item => item != event.target.value);
//   }

//   chartData = {
//     labels: costData.labels,
//     datasets: costData.datasets.filter(data => costItems.some(item => data.label == item))
//   };

//   chartInstance.destroy();
//   drawChart(chartType, chartStack);
// }

function onChangeCostGraph(type) {
  chartType = type;

  chartInstance.destroy();
  drawChart(chartType, chartStack);
}

function onChangeCostGraphStack(checked) {
  chartStack = checked;
  onChangeCostGraph(chartType)
}

function dispatchAction (actionName) {
  console.log('**************************');
  console.log(actionName);
  console.log(selectedCosts);
}
</script>

<template>
  <div class="card m-0 mb-1">
    <div class="card-header py-0 bg-dark-subtle text-center">出力条件</div>
    <div class="card-body p-0">
      <table class="table table-sm table-bordered m-0">
        <tbody>
          <tr>
            <td class="table-light align-middle text-nowrap"><i class="bi bi-calendar-week pe-1"></i>期間</td>
            <td class="align-middle">
              <div class="row d-flex align-items-center">
                <div class="col">
                  <div class="date-picker">
                    <VueDatePicker
                      v-model="date"
                      v-bind:disabled="btnDisabled"
                      format="yyyy/MM/dd"
                      locale="ja"
                      model-type="yyyy-MM-dd"
                      week-start="0"
                      :enable-time-picker="false"
                      :clearable="false"
                      :day-class="getDayClass"
                      :highlight="highlights"
                      :markers="markers"
                      :max-date="new Date()"
                      auto-apply
                      year-first
                      calendar-class-name="dp-custom-calendar"
                      @date-update="onChangeDate"
                    />
                  </div>
                </div>
                <div class="col col-auto">～</div>
                <div class="col">
                  <div class="date-picker col-auto">
                    <VueDatePicker
                      v-model="date"
                      v-bind:disabled="btnDisabled"
                      format="yyyy/MM/dd"
                      locale="ja"
                      model-type="yyyy-MM-dd"
                      week-start="0"
                      :enable-time-picker="false"
                      :clearable="false"
                      :day-class="getDayClass"
                      :highlight="highlights"
                      :markers="markers"
                      :max-date="new Date()"
                      auto-apply
                      year-first
                      calendar-class-name="dp-custom-calendar"
                      @date-update="onChangeDate"
                    />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="table-light align-middle"><i class="bi bi-geo-alt pe-1"></i>圃場</td>
            <td class="align-middle">
              <select class="form-select" aria-label="Default select example">
                <option selected>{{ field?.Name }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="table-light align-middle"><i class="bi bi-tree pe-1"></i>作物</td>
            <td class="align-middle">
              <Multiselect 
                  v-model="selectedCrops" 
                  :options="dataCrops" 
                  track-by="id" 
                  :show-labels="false" 
                  :multiple="true" 
                  label="name"
                  placeholder=""
              ></Multiselect>
            </td>
          </tr>
          <tr>
            <td class="table-light align-middle"><i class="bi bi-list-check pe-1"></i>費目</td>
            <td class="align-middle">
              <!-- <div class="btn-group btn-group-sm w-100 d-flex flex-row" role="group" aria-label="Basic radio toggle button group">
                <input type="checkbox" class="btn-check" name="btnCheckItem" id="btnCostItem1" value="人件費" @change="onChangeCostItem($event)" checked>
                <label class="btn btn-outline-success" for="btnCostItem1">人件費</label>

                <input type="checkbox" class="btn-check" name="btnCheckItem" id="btnCostItem2" value="育苗費" @change="onChangeCostItem($event)" checked>
                <label class="btn btn-outline-success ms-1" for="btnCostItem2">育苗費</label>

                <input type="checkbox" class="btn-check" name="btnCheckItem" id="btnCostItem3" value="肥料費" @change="onChangeCostItem($event)" checked>
                <label class="btn btn-outline-success ms-1" for="btnCostItem3">肥料費</label>

                <input type="checkbox" class="btn-check" name="btnCheckItem" id="btnCostItem4" value="農薬費" @change="onChangeCostItem($event)" checked>
                <label class="btn btn-outline-success ms-1" for="btnCostItem4">農薬費</label>

                <input type="checkbox" class="btn-check" name="btnCheckItem" id="btnCostItem5" value="農機具費" @change="onChangeCostItem($event)" checked>
                <label class="btn btn-outline-success ms-1" for="btnCostItem5">農機具費</label>

                <input type="checkbox" class="btn-check" name="btnCheckItem" id="btnCostItem6" value="その他" @change="onChangeCostItem($event)" checked>
                <label class="btn btn-outline-success ms-1" for="btnCostItem6">その他</label>
              </div> -->
              <Multiselect 
                  v-model="selectedCosts" 
                  :options="dataCosts" 
                  track-by="id" 
                  :show-labels="false" 
                  :multiple="true" 
                  label="name"
                  placeholder=""
                  @select="dispatchAction"
              ></Multiselect>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-header py-0 bg-dark-subtle text-center">出力結果</div>
    <div hidden>
    <div class="card-body p-1">
      <canvas id="chartCost"></canvas>
      <div class="btn-toolbar d-flex justify-content-center mt-2" role="toolbar" aria-label="Toolbar with button groups">
        <div class="btn-group btn-group-sm w-25" role="group" aria-label="Basic radio toggle button group">
          <input type="radio" class="btn-check" name="btnRadioGraph" id="btnRadioGraph1" value="bar" @change="onChangeCostGraph($event.target.value)" checked>
          <label class="btn btn-outline-primary" for="btnRadioGraph1"><i class="bi bi-bar-chart-line"></i></label>

          <input type="radio" class="btn-check" name="btnRadioGraph" id="btnRadioGraph2" value="line" @change="onChangeCostGraph($event.target.value)">
          <label class="btn btn-outline-primary" for="btnRadioGraph2"><i class="bi bi-graph-up"></i></label>

          <input type="radio" class="btn-check" name="btnRadioGraph" id="btnRadioGraph3" value="pie" @change="onChangeCostGraph($event.target.value)">
          <label class="btn btn-outline-primary" for="btnRadioGraph3"><i class="bi bi-pie-chart"></i></label>
        </div>

        <div class="btn-group btn-group-sm ms-3" role="group" aria-label="Basic radio toggle button group">
          <input type="checkbox" class="btn-check" name="btnCheckItem" id="btnCostGraphStack" value="btnCostGraphStack" @change="onChangeCostGraphStack($event.target.checked)">
          <label class="btn btn-outline-primary ms-1" for="btnCostGraphStack"><i class="bi bi-stack"></i></label>
        </div>
      </div>
    </div>
    </div>

    <div class="card-body p-0 h-100">
      <div class="row h-100">
        <!-- 外部URLのiframeは一時的にコメントアウト -->
        <!-- <div class="ratio ratio-1x1">
          <iframe src="https://famisuke.mtc-sams.org/costmanager/result?timeUnit=month&startDatetime=2021-01-01&endDatetime=2025-12-31&fieldId=9,10,11,1,2,3,6,8,4,5,7&cropId=1&continue"></iframe>
        </div> -->
        <div class="p-3">
          <p class="text-muted">コスト管理機能は現在準備中です</p>
        </div>
      </div>
    </div>



</div>
</template>

<style scoped>
</style>
